/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('../bootstrap');
require('../plugins');

import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';
import Vuelidate from 'vuelidate';

window.Vue = Vue;
Vue.use(BootstrapVue);
Vue.use(Vuelidate);


// TABLER 
//Vendor
import './src/autosize';
import './src/input-mask';
import './src/dropdown';

import './src/popover';
import './src/switch-icon';
import { EnableActivationTabsFromLocationHash } from './src/tab';
import './src/toast';
import './src/charts';
import jquery from 'jquery';


EnableActivationTabsFromLocationHash();

// END OF TABLER


// Mobile Menu toggle


$(document).ready(function(){

    $('.btn-note').on('click',function(){
        if(this.innerHTML == "... more")
        {
            $(`#note-${this.id} > .long-text`).removeClass('d-none');
            this.innerHTML = 'less';
        }
        else
        {
            $(`#note-${this.id} > .long-text`).addClass('d-none');
            this.innerHTML = '... more';
        }
    });
    
});






/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

Vue.component('example-component', require('./components/ExampleComponent.vue').default);
Vue.component('today-dashboard', require('./components/TodayDashboard.vue').default);

/* Residents */
// Resident
Vue.component('resident-create', require('./components/residents/Create.vue').default); 
Vue.component('resident-delete', require('./components/residents/Delete.vue').default); 
Vue.component('resident-edit-photo', require('./components/residents/EditPhoto.vue').default); 

// Nursing Assessment
Vue.component('nursing-assessment-create', require('./components/nursing-assessments/Create.vue').default); // Create nursing assessments

// Neurological Observation
Vue.component('neurological-observation-create', require('./components/neurological-observations/Create.vue').default); // Create neurological observations

// Accident / Incident Report
Vue.component('accident-incident-report-create', require('./components/accident-incident-reports/Create.vue').default); // Create accident / incident reports
Vue.component('accident-incident-report-add-rn-report', require('./components/accident-incident-reports/AddRNReport.vue').default); // Add RN Report to accident / incident report

// Care Plans
//-- Long term
Vue.component('long-term-create', require('./components/care-plans/LongTermCreate.vue').default);
Vue.component('long-term-review', require('./components/care-plans/LongTermReview.vue').default); 
//-- Short term
Vue.component('short-term-create', require('./components/care-plans/ShortTermCreate.vue').default);
Vue.component('short-term-review', require('./components/care-plans/ShortTermReview.vue').default);
Vue.component('short-term-add-intervention', require('./components/care-plans/ShortTermAddIntervention.vue').default);
Vue.component('short-term-acknowledge-intervention', require('./components/care-plans/ShortTermAcknowledgeIntervention.vue').default);
Vue.component('short-term-discontinue-intervention', require('./components/care-plans/ShortTermDiscontinueIntervention.vue').default);
//-- Wound
Vue.component('wound-create', require('./components/care-plans/WoundCreate.vue').default);
Vue.component('wound-review', require('./components/care-plans/WoundReview.vue').default); 
Vue.component('wound-monitor', require('./components/care-plans/WoundMonitor.vue').default); 
Vue.component('wound-edit-photo', require('./components/care-plans/WoundEditPhoto.vue').default); 
//-- Initial Nursing
Vue.component('initial-nursing-create', require('./components/care-plans/InitialNursingCreate.vue').default);
Vue.component('initial-nursing-review', require('./components/care-plans/InitialNursingReview.vue').default);
//-- Activity
Vue.component('activity-create', require('./components/care-plans/ActivityCreate.vue').default);
Vue.component('activity-add-intervention', require('./components/care-plans/ActivityAddIntervention.vue').default);
Vue.component('activity-discontinue-intervention', require('./components/care-plans/ActivityDiscontinueIntervention.vue').default);
Vue.component('activity-review', require('./components/care-plans/ActivityReview.vue').default);

/* Note Create */
Vue.component('note-create', require('./components/notes/Create.vue').default);

/* Employees */
Vue.component('employee-create', require('./components/employees/Create.vue').default); 
Vue.component('employee-delete', require('./components/employees/Delete.vue').default); 
Vue.component('employee-edit-photo', require('./components/employees/EditPhoto.vue').default); 

/* Facility */
// Area
Vue.component('area-create', require('./components/areas/Create.vue').default); // Create
Vue.component('area-delete', require('./components/areas/Delete.vue').default); // Delete

// Room
Vue.component('room-create', require('./components/rooms/Create.vue').default); 
Vue.component('room-delete', require('./components/rooms/Delete.vue').default); 

// Bed
Vue.component('bed-create', require('./components/beds/Create.vue').default); 
Vue.component('bed-delete', require('./components/beds/Delete.vue').default); 
/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const app = new Vue({
    el: '#app',
});





